// extracted by mini-css-extract-plugin
export default {"fileinfo__card":"CasFormFileInfo_fileinfo__card__jlVuj","fileinfo__container":"CasFormFileInfo_fileinfo__container__fcSYP","fileinfo__name":"CasFormFileInfo_fileinfo__name__G1sbf"};